// extracted by mini-css-extract-plugin
export default {"departments":"gH-z","departmentHeading":"hH-z","departmentSection":"iH-z","departmentName":"jH-z","departmentLink":"kH-z","expandIcon":"lH-z"};